/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";

export function useExportQuery(
  title: string,
  subtitle: string,
  source: string | undefined | null,
  calendarMark: number[] | null | undefined,
) {
  const exportBuilder = useExport();
  const [commodities] = useParameter<number>("@commodities");
  const [units] = useParameter<number>("@units");
  const [refYear] = useParameter<number>("@ref_year");
  const [cbotDate] = useParameter<number>("@cbot_date");

  React.useEffect(() => {
    exportBuilder.set("title", title);
    exportBuilder.set("subtitle", subtitle);
    exportBuilder.set("source", source);
    exportBuilder.set("reportDefinition", {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@calendar": calendarMark || [],
        "@commodities": commodities,
        "@units": units,
        "@ref_year": refYear,
        "@cbot_date": cbotDate,
      },
    });
  }, [title, subtitle, exportBuilder, calendarMark, commodities, units, refYear, cbotDate, source]);
}
